import { useEffect, useState, createContext, useContext, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const BillingCtx = createContext(null);

export function BillingProvider({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);

  const refresh = useCallback(async () => {
    if (!user) { setStatus(null); return; }
    try {
      const { data } = await api.get("/billing/status");
      setStatus(data);
    } catch {
      setStatus(null);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BillingCtx.Provider value={{ status, refresh }}>
      {children}
    </BillingCtx.Provider>
  );
}

export const useBilling = () => useContext(BillingCtx);
